import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { Instagram, Facebook, Linkedin, Search, MoreHorizontal, Phone } from "lucide-react";

interface ReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}

const sources = [
  { id: "instagram", label: "Instagram", icon: Instagram },
  { id: "facebook", label: "Facebook", icon: Facebook },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin },
  { id: "google", label: "Google", icon: Search },
  { id: "andet", label: "Andet", icon: MoreHorizontal },
];

const ReferralModal = ({ isOpen, onClose, onComplete }: ReferralModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSelect = async (sourceId: string) => {
    setIsSubmitting(true);
    try {
      await supabase.from("referral_responses").insert({ source: sourceId });
    } catch (error) {
      console.error("Error saving referral source:", error);
    }
    setIsSubmitting(false);
    onComplete();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center">
            Hvor har du hørt om os?
          </DialogTitle>
          <DialogDescription className="text-center">
            Det hjælper os med at forbedre vores synlighed
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-3 mt-4">
          {sources.map((source) => (
            <Button
              key={source.id}
              variant="outline"
              className="h-16 flex flex-col gap-1 hover:bg-primary/5 hover:border-primary/30"
              onClick={() => handleSelect(source.id)}
              disabled={isSubmitting}
            >
              <source.icon className="h-5 w-5" />
              <span className="text-sm">{source.label}</span>
            </Button>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t">
          <Button
            variant="ghost"
            className="w-full text-muted-foreground"
            onClick={() => {
              handleSelect("skipped");
            }}
            disabled={isSubmitting}
          >
            Spring over
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralModal;
